import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bd541fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex container lg:px-8 xl:px-0 py-16 -gap-x-4" }
const _hoisted_2 = { class: "flex-none" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex-1 flex flex-col justify-between text-white" }
const _hoisted_5 = { class: "text-3xl font-bold mb-4" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  class: "container lg:px-8 xl:px-0",
  style: {"max-width":"1280px"}
}
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col items-center mb-12"
}
const _hoisted_9 = { class: "py-4 text-3xl font-bold" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-1 w-20 border-t-4 border-highlight" }, null, -1))
const _hoisted_11 = { class: "flex justify-around py-8" }
const _hoisted_12 = { class: "text-3xl text-green-500 py-2" }
const _hoisted_13 = { class: "container lg:px-8 xl:px-0" }
const _hoisted_14 = {
  key: 3,
  class: "w-full flex justify-center py-10"
}
const _hoisted_15 = {
  class: "container lg:px-8 xl:px-0 mb-16",
  style: {"max-width":"1280px"}
}
const _hoisted_16 = { class: "flex flex-col items-center mb-12" }
const _hoisted_17 = { class: "py-4 text-3xl font-bold" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-1 w-20 border-t-4 border-green-500" }, null, -1))
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  class: "container lg:px-8 xl:px-0",
  style: {"max-width":"1280px"}
}
const _hoisted_21 = { class: "flex -gap-x-4" }
const _hoisted_22 = { class: "flex-none" }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { class: "flex-1 flex flex-col justify-between text-gray-800" }
const _hoisted_25 = { class: "text-2xl font-bold mb-4" }
const _hoisted_26 = { class: "w-full h-full relative" }
const _hoisted_27 = ["alt"]
const _hoisted_28 = {
  class: "container lg:px-8 xl:px-0",
  style: {"max-width":"1280px"}
}
const _hoisted_29 = {
  key: 0,
  class: "flex flex-col items-center mb-12"
}
const _hoisted_30 = { class: "py-4 text-3xl font-bold" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-1 w-20 border-t-4 border-highlight" }, null, -1))
const _hoisted_32 = {
  class: "container lg:px-8 xl:px-0",
  style: {"max-width":"1280px"}
}
const _hoisted_33 = {
  key: 0,
  class: "flex flex-col items-center mb-12"
}
const _hoisted_34 = { class: "py-4 text-3xl font-bold" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-1 w-20 border-t-4 border-highlight" }, null, -1))
const _hoisted_36 = { class: "flex justify-around py-8" }

import { reactive, computed, shallowRef } from 'vue';
import { useMeta } from 'quasar';
import SvTimeline from 'components/SvTimeline.vue';
import SvVerticalTabs from 'components/SvVerticalTabs.vue';
import { useMetaStore } from 'stores/modules/meta';
import { useI18n } from 'vue-i18n';


import { usePageStore } from 'stores/modules/page';
import SvThumbnail from 'src/components/SvThumbnail.vue';

const __default__ = {
  async preFetch({ store, currentRoute }) {
    const pageStore = usePageStore(store);
    await pageStore.fetch({ url: currentRoute.path });
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IntroPage',
  setup(__props) {

const { t, locale } = useI18n();

const pageStore = usePageStore();
const page = computed(() => pageStore.page);

const metaStore = useMetaStore();
useMeta(
  Object.assign({}, metaStore.meta, {
    title: page.value.title,
    titleTemplate: (title: string) => `${title} - ${metaStore.meta.title}`,
  })
);

const state = reactive({
  visible: false,
  address: 0,
});

const player = shallowRef();
const handleMounted = (payload: any) => {
  player.value = payload.player;
  player.value?.play();
};

const background = (image: string, size = 'cover') => {
  return image
    ? `background: url('${image}') no-repeat; background-size: ${size}; background-position: center center`
    : '';
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_vue_video_player = _resolveComponent("vue-video-player")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "flex justify-center" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.regions, (region) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: region.id
        }, [
          (region.type === 'summary')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "w-full h-bg flex justify-center",
                style: _normalizeStyle(background(region.image))
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", {
                      class: "w-8 h-8 m-0.5",
                      src: region.icon,
                      alt: "logo"
                    }, null, 8, _hoisted_3)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(region.name), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((region.summary ?? '').split('\n'), (p, i) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: "mb-6",
                          key: i
                        }, _toDisplayString(p), 1))
                      }), 128))
                    ]),
                    (region.url && region.content)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          class: "mt-5 w-40 h-11",
                          "no-caps": "",
                          square: "",
                          padding: "0",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (state.visible = true))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "w-full h-11 flex justify-center items-center rounded text-white text-base horizontal-gradient",
                              innerHTML: region.content
                            }, null, 8, _hoisted_6)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true),
          (
          region.type === 'data-list' &&
          region.children?.length &&
          region.name !== _unref(t)('Intro.national')
        )
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "w-full flex justify-center py-10",
                style: _normalizeStyle(background(region.image))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  (region.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(region.name), 1),
                        _hoisted_10
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: child.id,
                        class: "text-center"
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                            return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                          }), 128))
                        ]),
                        _createElementVNode("div", null, _toDisplayString(child.name), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true),
          (region.type === 'time-list' && region.children?.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "w-full flex justify-center py-10",
                style: _normalizeStyle(background(region.image))
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(SvTimeline, { region: region }, null, 8, ["region"])
                ])
              ], 4))
            : _createCommentVNode("", true),
          (region.type === 'document')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(region.name), 1),
                    _hoisted_18
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(`ql-editor ${_unref(locale)?.split('-')[0]}`),
                    innerHTML: region.content
                  }, null, 10, _hoisted_19)
                ])
              ]))
            : _createCommentVNode("", true),
          (
          region.type === 'data-list' &&
          region.children?.length &&
          region.name === _unref(t)('Intro.national')
        )
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "bg-china w-full flex justify-center py-10",
                style: _normalizeStyle(background(region.image))
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      (region.icon)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "w-8 h-8",
                            src: region.icon,
                            alt: region.name
                          }, null, 8, _hoisted_23))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(region.name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        class: "ditu -translate-y-8",
                        src: "/img/di_tu1@2x.png",
                        alt: _unref(t)('Intro.atlas')
                      }, null, 8, _hoisted_27),
                      _createVNode(_component_q_icon, {
                        class: "star star-beijing animate-ping",
                        name: "mdi-star-circle",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (state.address = 2))
                      }),
                      _createVNode(_component_q_icon, {
                        class: "star star-nanjing animate-ping",
                        name: "mdi-star-circle",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (state.address = 1))
                      }),
                      _createVNode(_component_q_icon, {
                        class: "star star-shenzhen animate-ping",
                        name: "mdi-star-circle",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (state.address = 0))
                      })
                    ]),
                    _createVNode(SvVerticalTabs, {
                      class: "absolute top-1/2 left-1/2 xl:translate-x-24 xl:translate-y-0 lg:-translate-x-18 lg:-translate-y-10",
                      style: {"width":"600px"},
                      tab: state.address,
                      "onUpdate:tab": _cache[4] || (_cache[4] = ($event: any) => ((state.address) = $event)),
                      regions: region.children
                    }, null, 8, ["tab", "regions"])
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true),
          (region.type === 'image-list' && region.children?.length && region.name !== _unref(t)('Intro.keyfacts'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: "w-full flex justify-center py-10",
                style: _normalizeStyle(background(region.image))
              }, [
                _createElementVNode("div", _hoisted_28, [
                  (region.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(region.name), 1),
                        _hoisted_31
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(SvThumbnail, {
                    regions: region.children,
                    "grid-class": "2xl:grid-cols-5 xl:grid-cols-5 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1",
                    class: "bg-card",
                    imageHeight: "300px",
                    ratio: "9/16",
                    autoplay: "",
                    infinite: ""
                  }, null, 8, ["regions"])
                ])
              ], 4))
            : _createCommentVNode("", true),
          (region.type === 'image-list' && region.children?.length && region.name === _unref(t)('Intro.keyfacts'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 6,
                class: "w-full flex justify-center py-10",
                style: _normalizeStyle(background(region.image))
              }, [
                _createElementVNode("div", _hoisted_32, [
                  (region.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(region.name), 1),
                        _hoisted_35
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: child.id,
                        class: "text-center"
                      }, [
                        (child.image)
                          ? (_openBlock(), _createBlock(_component_q_img, {
                              key: 0,
                              style: {"width":"200px","height":"115px"},
                              src: child.image,
                              alt: child.name,
                              loading: "lazy"
                            }, {
                              loading: _withCtx(() => [
                                _createVNode(_component_q_spinner_dots, {
                                  color: "primary",
                                  size: "1.5rem"
                                })
                              ]),
                              _: 2
                            }, 1032, ["src", "alt"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createVNode(_component_q_dialog, {
        modelValue: state.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.visible) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, {
            class: "w-2/3 h-2/3",
            style: {"max-width":"none"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "w-full h-full p-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_vue_video_player, {
                    class: "video-player vjs-big-play-centered w-full h-full",
                    src: _unref(t)('Intro.video.src'),
                    poster: "videos/video.jpg?d=230809",
                    crossorigin: "anonymous",
                    playsinline: "",
                    controls: "",
                    volume: 0.6,
                    "playback-rates": [0.7, 1.0, 1.5, 2.0],
                    onMounted: _cache[5] || (_cache[5] = ($event: any) => (handleMounted($event)))
                  }, null, 8, ["src"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})